'use client';

import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useContactModal } from '../ContactModal/ContactModalContext';
import { useIsMobile } from '../ContactModal/useIsMobile';
import { Button } from '@/shared/ui/atoms';
import { fixedCtaMock } from '@/shared/store/mocks';
import styles from './fixed-cta-button.module.scss';

const ROOT_MARGIN = '-10px 0px 0px 0px';
const THRESHOLD = 0;

export default function FixedCtaButton() {
  const { buttonLabel, ariaLabel, hideZoneIds } = fixedCtaMock;
  const isMobile = useIsMobile();
  const { openModal: openContactModal } = useContactModal();
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    if (!isMobile) return;

    const inZone: Record<string, boolean> = {};
    hideZoneIds.forEach((id) => {
      inZone[id] = false;
    });

    const updateHidden = () => {
      const anyInZone = hideZoneIds.some((id) => inZone[id]);
      setIsHidden(anyInZone);
    };

    const observers: IntersectionObserver[] = [];

    hideZoneIds.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inZone[id] = entry.isIntersecting;
            updateHidden();
          });
        },
        { root: null, rootMargin: ROOT_MARGIN, threshold: THRESHOLD }
      );
      observer.observe(el);
      observers.push(observer);
    });

    // початковий стан: перевірити, чи Hero зараз у видимій зоні
    const hero = document.getElementById('home');
    if (hero) {
      const rect = hero.getBoundingClientRect();
      inZone.home = rect.top < window.innerHeight && rect.bottom > 0;
      updateHidden();
    }

    return () => observers.forEach((o) => o.disconnect());
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <div className={clsx(styles.wrap, isHidden && styles.wrapHidden)} aria-hidden={isHidden}>
      <Button type="button" className={styles.button} onClick={openContactModal} aria-label={ariaLabel}>
        {buttonLabel}
      </Button>
    </div>
  );
}
